export default function handleBlockedStateDecline(responseData) {
  if (responseData?.declined_blocked_state && responseData?.redirect) {
    window.location.assign(responseData.redirect);
    return true;
  }

  return false;
}
